import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { Category } from '../../model/category';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  API_BASE_PATH = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAll(): Observable<Category[]>{
    return this.http.get<Category[]>(`${this.API_BASE_PATH}business-category`);
  }
  
  getById(id:number): Observable<Category>{
    return this.http.get<Category>(`${this.API_BASE_PATH}business-category/${id}`);
  }
}
